import React, { useState } from "react";
import "@ant-design/compatible/assets/index.css";
import { Button, Collapse, DatePicker, Select, Form, message } from "antd";
import moment from "moment";

import HmgMainDropdown from "../../components/Common/DataAttachedElements/HmgDropdown";

import { useGetHmg } from "../../hooks/hmg.hooks";
import { useRequestReportQc } from "../../hooks/qcApi.hooks";

import { formItemLayout, formItemLayoutWithOutLabel } from "../../utils/UI";

const { Panel } = Collapse;

const ReportQc = () => {
  const [form] = Form.useForm();

  const [hmg, setHmg] = useState();
  const [date, setDate] = useState();
  const [emails, setEmails] = useState();

  const emailValidator = async (rule, values) => {
    if (values && values.length > 0) {
      const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const invalidInputs = values.filter(
        (value) => !value.match(emailRegex)
      );
      if (invalidInputs.length === 0) {
        return Promise.resolve();
      } else if (invalidInputs.length === 1) {
        return Promise.reject(
          invalidInputs.join("") + " is not a valid email"
        );
      } else {
        return Promise.reject(
          invalidInputs.slice(0, -1).join(", ") +
          " and " +
          invalidInputs.slice(-1) +
          " are not valid emails"
        );
      }
    } else {
      return Promise.reject("Please Enter Emails");
    }
  };

  const { data: hmgsList } = useGetHmg(hmg, {
    enabled: !!hmg,
  });

  const { mutate: requestReportQc } = useRequestReportQc({
    onSuccess: (response) => {
      message.success(response.message);
      clearFields();
    },
    onError: (error) => {
      // console.log(error);
      message.error(error.response?.data?.message ?? "Server Error");
    },
  });

  const clearFields = () => {
    form.resetFields();
    setHmg(null);
    setDate(null);
    setEmails(null);
  };

  const requestReport = () => {
    requestReportQc({
      mgmtGroup: hmgsList.hmg_name,
      businessDate: moment(date).format("MM/DD/YYYY"),
      recipients: emails.join('|')
    });
  }

  return (
    <>
      <div className="container_ab">
        <Collapse defaultActiveKey={["1"]} expandIconPosition="end">
          <Panel header="Portfolio/Group QC (Ad hoc)" key="1">
            <Form form={form}>
              <HmgMainDropdown
                value={hmg}
                onChange={setHmg}
                placeholder="Please Select Hotel Management Group" />
              <Form.Item
                {...formItemLayout}
                name="businessDate"
                label="Business Date"
                placeholder="Please Enter Business Date"
                rules={[
                  {
                    required: true,
                    message: "Business Date required",
                  },
                ]}
              >
                <DatePicker
                  disabledDate={(current) =>
                    current > moment()
                  }
                  format="YYYY-MM-DD"
                  placeholder="Please Enter Business Date"
                  style={{ width: "100%" }}
                  value={date}
                  onChange={setDate}
                />
              </Form.Item>
              <Form.Item
                {...formItemLayout}
                name="emails"
                label="E-mail To :"
                rules={[
                  {
                    validator: emailValidator,
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Enter Emails"
                  optionFilterProp="children"
                  mode="tags"
                  value={emails}
                  onChange={setEmails}
                  notFoundContent={null}
                ></Select>
              </Form.Item>
              <Form.Item {...formItemLayoutWithOutLabel}>
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={!(hmg && date && emails)}
                  onClick={requestReport}>
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Panel>
        </Collapse>
      </div>
    </>
  );
}

export default ReportQc;
